module.exports = __webpack_public_path__ + "img/GU.0d4c6d29.svg";